<template>
  <div class="video-list">
    <div v-for="(item, index) in datalist" :key="index" class="data-item" @click="play(item)">
      <div class="video-preview" :style="previewbg(item.preview)">
        <div class="icon-play"></div>
      </div>
      <div class="video-caption">
        <h3>{{item.title}}</h3>
        <p v-if="category === 'games'">作者: {{item.author}}</p>
        <div class="btn-outlink"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    datalist: Array,
    category: String
  },
  methods: {
    previewbg(src) {
      let url = "";
      if (/(shadowresou)/.test(src)) {
        var n = src.lastIndexOf("/");
        var str1 = src.slice(0, n);
        var str2 = "/PreviewPic/Pre" + src.slice(n+1);
        url = str1 + str2;
      } else {
        url = src;
      }
      return {
        backgroundImage: src
          ? `url(http://shadow.caa.edu.cn${url})`
          : `url("img/video-default-bg.jpg")`
      };
    },
    play(video) {
      this.$emit("play", video);
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/base";
.video-list {
  .data-item {
    margin-bottom: 1rem;
  }
}
.video-preview {
  position: relative;
  height: 56.25vw;
  overflow: hidden;
  background-position-y: center;
  background-size: cover;
  background-repeat: no-repeat;
  @include img-fluid;

  .icon-play {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
    width: 3rem;
    height: 3rem;
    border: 1px solid #fff;
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 100%;
  }

  .icon-play:after {
    content: "";
    position: relative;
    left: 50%;
    margin-left: -0.125rem;
    @include center-y;
    display: block;
    width: 0px;
    height: 0px;
    border: 0.5rem transparent solid;
    border-left-color: #fff;
  }
}

.video-caption {
  position: relative;
  padding: 0.5rem 1rem;
  background-color: #f7f1da;

  @include title-h3(0.875rem);
  h3 {
    margin: 0;
    font-size: 0.875rem;
    line-height: 1.2;
    height: 1.05rem;

    &::before,
    &::after {
      height: 1.05rem;
    }

    &::before {
      background-image: url("~@/assets/img/video/title-left.png");
    }

    &::after {
      background-image: url("~@/assets/img/video/title-right.png");
    }
  }

  p {
    margin: 0;
    font-size: 0.875rem;
    line-height: 1.8;
  }

  .btn-outlink {
    display: none;
    position: absolute;
    top: 1rem;
    right: 1rem;
    width: 1.25rem;
    height: 1.25rem;
    background-image: url("~@/assets/img/video/icon-outlink.png");
    background-repeat: no-repeat;
    background-size: 100%;
  }
}
</style>
